module.exports = __webpack_public_path__ + "static/media/MentorDanielle.d791090b.jpeg";